<!--
  --
  -- 免許証情報設定 ページ
  --
  -->
<template>
  <c-container form>
    <c-license-group
      :license="license"
      @submit="onSubmit"
    >
      <!-- タイトル -->
      <template #title>運転免許証情報を設定</template>

      <!-- 説明文 -->
      <template>
        <p>
          運転免許証の情報を入力して下さい。
        </p>
      </template>

      <template #submit-text>次へ</template>
    </c-license-group>

    <!-- タイムアウト制御 -->
    <c-timeout/>
  </c-container>
</template>

<script>
import page from '@/mixins/page'
import CLicenseGroup from './CLicenseGroup'
import CTimeout from '../CTimeout'

import { run } from '@/libs/a'

export default {
  name: 'License',
  mixins: [
    page('運転免許証情報を設定')
  ],
  components: {
    CLicenseGroup,
    CTimeout
  },
  computed: {
    license () {
      return this.getters['register/license']
    }
  },
  methods: {
    /**
     * Submit ボタンが押された
     *
     * @param {Object} form 入力されたフォーム内容
     * @param {Function} failed エラー時に呼び出すコールバック関数
     */
    onSubmit (form, failed) {
      run(async () => {
        // store に個人情報を保存する
        this.commit('register/setLicense', form)

        // 次のページへ
        await this.goTo({ name: 'register/confirm' })
      })
    }
  }
}
</script>
